import React from 'react';
import ReUsableBanner from '../../../../components/common/ReUsableBanner';

const MenuBanner = () => {
	const asideImage = '/assets/menu-banner.png';
	const smallTitle = 'Menu';
	const headerContent = 'Delicious & Diverse Menu Options';
	const paraContent = `Explore our mouthwatering selection of dishes, crafted with fresh ingredients to satisfy every craving. From hearty meals to light bites, we cater to all tastes and occasions!`;

	return (
		<div>
			<ReUsableBanner
				asideImage={asideImage}
				smallTitle={smallTitle}
				headerContent={headerContent}
				paraContent={paraContent}
			/>
		</div>
	);
};

export default MenuBanner;
